import { render, staticRenderFns } from "./SiteNavDesktopTopItem.vue?vue&type=template&id=4b111c87&scoped=true&lang=pug&"
import script from "./SiteNavDesktopTopItem.vue?vue&type=script&lang=js&"
export * from "./SiteNavDesktopTopItem.vue?vue&type=script&lang=js&"
import style0 from "./SiteNavDesktopTopItem.vue?vue&type=style&index=0&id=4b111c87&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b111c87",
  null
  
)

export default component.exports